import React from "react";
import { Divider } from "@origin-digital/ods-core";
import linkContent from "../../screens/Manage/content.json";
import { Description, DescriptionList } from "../DescriptionList";
import content from "./content.json";
import { onPasswordEditClick } from "./helpers";

export const Password = () => (
  <DescriptionList data-id="password" heading={content.heading}>
    <Description
      data-id="edit-password"
      label={content.currentPassword}
      value={content.currentPasswordValue}
      linkText={linkContent.links.updatePassword}
      onClick={onPasswordEditClick}
    />
    <Divider />
  </DescriptionList>
);
